module.exports = __webpack_public_path__ + "img/pdf-icon.5347453.svg?v=1762502055057";